import { SLOTS } from './slots.js'

// User reports — moderation queue for reported members. Primary is an avatar + name
// linking to the user's social tab; review actions (dismiss / clear icon) live in the
// page's actions snippet; the Reports cell opens the per-report reason/details rows.
// Profile visibility uses an inline badge map (per-entity states don't warrant a shared
// lib/ui/badges.js domain).

const VISIBILITY_BADGES = {
  public: { label: 'Public', badgeClass: 'badge-success' },
  friends_only: { label: 'Friends Only', badgeClass: 'badge-info' },
  private: { label: 'Private', badgeClass: 'badge-neutral' }
}

export default {
  key: 'user_report',
  label: 'User Report',
  icon: 'user_reports',
  columns: [
    { slot: SLOTS.PRIMARY, field: 'icon_image.image_url', label: 'User', renderer: 'avatar', labelField: 'name', link: 'url' },
    { slot: SLOTS.STATUS, field: 'profile_visibility', label: 'Profile Visibility', renderer: 'state_badge', badges: VISIBILITY_BADGES },
    { slot: SLOTS.STATUS, field: 'user_reports_received', label: 'Reports', renderer: 'report_summary' },
    { slot: SLOTS.TEMPORAL, field: 'created_at', label: 'User Since', renderer: 'date' }
  ],
  empty: { icon: 'user_reports', message: 'No users found.' },
  defaultView: 'table',
  compact: { show: [SLOTS.PRIMARY, SLOTS.STATUS] }
}
